import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import AutTable from '../../blocks/aut-grid-table/index';
import Conditional from '../../common/conditional';
import ETSummaryItem from './etSummaryItem';
import Form from '../../common/form';

import { ETInspectedItem, ETSummarySheetData } from '../../../utils/models';
import {
	getETSummaryDummyData,
	getinspectionItemTableColumns,
} from '../../../utils/data';

class ETSummaryForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		general: Joi.string().min(10).required().label('Summary'),
		remarks: Joi.string()
			.min(10)
			.required()
			.label('Remarks and Recommendations'),
		inspectedItems: Joi.array()
			.min(1)
			.items(
				Joi.object({
					srNo: Joi.number().positive().required().label('SR No'),
					inspectedItem: Joi.string().min(3).required().label('Inspected Item'),
					observation: Joi.string().required().label('Observation / Result'),
					remark: Joi.string().min(3).required().label('Remarks'),
				})
			)
			.required()
			.label('Inspected Items'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	onAddItem = (item: ETInspectedItem) => {
		const data: any = { ...this.state.data };
		data.inspectedItems = [...data.inspectedItems];
		data.inspectedItems.push({
			...item,
			srNo: this.state.data.inspectedItems.length + 1,
		});

		this.setState({ data });
	};

	onDeleteItem = (item: ETInspectedItem): void => {
		const data = { ...this.state.data };
		data.inspectedItems = data.inspectedItems.filter(
			(i: ETInspectedItem) => i.srNo !== item.srNo
		);

		this.setState({ data });
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<React.Fragment>
				<ETSummaryItem onAdd={this.onAddItem} />

				<div className="divider my-4"></div>

				<AutTable
					tableColumns={getinspectionItemTableColumns()}
					data={this.state.data.inspectedItems}
					onDeleteItem={this.onDeleteItem}
				/>

				<Conditional isVisible={this.state.data.inspectedItems.length > 0}>
					<div className="divider my-4"></div>
				</Conditional>

				<form autoComplete="off" onSubmit={this.handleSubmit}>
					<div className="row">
						<div className="col">
							{this.renderTextArea({
								name: 'general',
								label: 'Summary',
								rows: '6',
								placeholder: 'Enter at least 10 characters',
							})}
						</div>

						<div className="col">
							{this.renderTextArea({
								name: 'remarks',
								label: 'Remarks and Recommendations',
								rows: '6',
								placeholder: 'Enter at least 10 characters',
							})}
						</div>
					</div>

					{this.renderButton('Proceed')}
				</form>
			</React.Fragment>
		);
	}
}

export default ETSummaryForm;

const initialData: ETSummarySheetData = getETSummaryDummyData();
